import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';


const AddPriceModal = ({ modalVisible, handleClose, handleAddEntry }) => {
  const [price, setPrice] = useState('');
  const [pricingFor, setPricingFor] = useState('');
  const [group, setGroup] = useState('');
  const [account, setAccount] = useState('');
  const [procedure, setProcedure] = useState('');

  const handleSubmit = async () => {
    try {
      const data = {
        price,
        pricingFor,
        group,
        account,
        procedure,
      };

      
      handleAddEntry(data); 
      setPrice('');
      setPricingFor('');
      setGroup('');
      setAccount('');
      setProcedure('');
      handleClose();
    } catch (error) {
      console.error('Error adding entry:', error);
      if (error.response) {
        console.error('Server responded with:', error.response.status, error.response.data);
      } else if (error.request) {
        console.error('Request was made but no response received:', error.request);
      } else {
        console.error('Error in setup:', error.message);
      }
    }
  };

  const renderDropdowns = () => {
    const groupOptions = (
      <div key="groupOptions">
        <label htmlFor="group" className="form-label" style={{ fontWeight: 'bold' }}>
          Group:
        </label>
        <select
          id="group"
          className="form-select"
          value={group}
          onChange={(e) => setGroup(e.target.value)}
          style={{ marginBottom: '15px', borderRadius: '5px' }}
        >
          <option value="">Select a Group</option>
          <option value="Group 1">Group 1</option>
          <option value="Group 2">Group 2</option>
          <option value="Group 3">Group 3</option>
        </select>
      </div>
    );

    const accountOptions = (
      <div key="accountOptions">
        <label htmlFor="account" className="form-label" style={{ fontWeight: 'bold' }}>
          Account:
        </label>
        <select
          id="account"
          className="form-select"
          value={account}
          onChange={(e) => setAccount(e.target.value)}
          style={{ marginBottom: '15px', borderRadius: '5px' }}
        >
          <option value="">Select an Account</option>
          <option value="Account 1">Account 1</option>
          <option value="Account 2">Account 2</option>
          <option value="Account 3">Account 3</option>
        </select>
      </div>
    );

    const procedureOptions = (
      <div key="procedureOptions">
        <label htmlFor="procedure" className="form-label" style={{ fontWeight: 'bold' }}>
          Procedure:
        </label>
        <select
          id="procedure"
          className="form-select"
          value={procedure}
          onChange={(e) => setProcedure(e.target.value)}
          style={{ marginBottom: '15px', borderRadius: '5px' }}
        >
          <option value="">Select a Procedure</option>
          <option value="Procedure 1">Procedure 1</option>
          <option value="Procedure 2">Procedure 2</option>
          <option value="Procedure 3">Procedure 3</option>
        </select>
      </div>
    );

    // Check which option is selected in Pricing For and return the corresponding dropdowns
    switch (pricingFor) {
      case 'Account':
        return accountOptions; 
      case 'Group':
        return groupOptions;
      case 'Account + Procedure':
        return (
          <>
            {accountOptions}
            {procedureOptions}
          </>
        );
      case 'Group + Procedure':
        return (
          <>
            {groupOptions}
            {procedureOptions}
          </>
        );
      default:
        return null;
    }
  };

  return (
    <Modal show={modalVisible} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontWeight: 'bold', fontSize: '1.5rem' }}>Add Price</Modal.Title>
      </Modal.Header>
      <h2 style={{color:"#004aad"}}>Details</h2>
      <Modal.Body style={{ padding: '10px', borderTop: '2px solid #007bff',backgroundColor:"#f4f4f4" }}>
        <div className="mb-3">
          <label htmlFor="price" className="form-label" style={{ fontWeight: 'bold' }}>
            Price (£):
          </label>
          <input
            type="number"
            className="form-control"
            id="price"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            min="0"
            step="1"
            placeholder="Enter price"
            style={{ marginBottom: '15px', borderRadius: '5px' }}
          />
          <label htmlFor="pricingFor" className="form-label" style={{ fontWeight: 'bold' }}>
            Pricing For:
          </label>
          <select
            id="pricingFor"
            className="form-select"
            value={pricingFor}
            onChange={(e) => setPricingFor(e.target.value)}
            style={{ marginBottom: '15px', borderRadius: '5px' }}
          >
            <option value="">Select Pricing For</option>
            <option value="Account">Account</option>
            <option value="Group">Group</option>
            <option value="Group + Procedure">Group + Procedure</option>
            <option value="Account + Procedure">Account + Procedure</option>
          </select>

          {/* Render additional fields based on pricingFor selection */}
          {renderDropdowns()}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button style={{backgroundColor:"#004aad"}} onClick={handleSubmit}>
          Add
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddPriceModal;
